export const ADMINISTRATIVE_LEAVES_TABLE_COLUMNS_KEY = 'administrativeLeaves'

// Renderer functions
const defaultRenderer = (value) => {
  if (value === null) return '--'
  if (typeof value === 'string' && value.trim() === '') return '--'
  return value || '--'
}

const tipoViaRenderer = (value) => {
  if (value === null || (typeof value === 'string' && value.trim() === '')) {
    return '--'
  }
  return value || '--'
}

export const LEAVES_TABLE_COLUMNS = [
  {
    field: 'cups',
    align: 'left',
    width: 220,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'comunidad_autonoma',
    align: 'left',
    width: 150,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'provincia',
    align: 'left',
    width: 130,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'municipio',
    align: 'left',
    width: 150,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'cp',
    align: 'left',
    width: 100,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'tipo_via',
    align: 'left',
    width: 100,
    sorting: true,
    renderer: tipoViaRenderer,
  },
  {
    field: 'calle',
    align: 'left',
    width: 200,
    sorting: true,
    cellStyle: {
      whiteSpace: 'wrap',
    },
    renderer: defaultRenderer,
  },
  {
    field: 'numero_finca',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'portal',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'escalera',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'piso',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'puerta',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
]

export const EXPORT_LEAVES_TABLE_COLUMNS = [
  {
    field: 'cups',
    align: 'left',
    width: 220,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'comunidad_autonoma',
    align: 'left',
    width: 150,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'provincia',
    align: 'left',
    width: 130,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'municipio',
    align: 'left',
    width: 150,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'cp',
    align: 'left',
    width: 100,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'tipo_via',
    align: 'left',
    width: 100,
    sorting: true,
    renderer: tipoViaRenderer,
  },
  {
    field: 'calle',
    align: 'left',
    width: 200,
    sorting: true,
    cellStyle: {
      whiteSpace: 'wrap',
    },
    renderer: defaultRenderer,
  },
  {
    field: 'numero_finca',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'portal',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'escalera',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'piso',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
  {
    field: 'puerta',
    align: 'left',
    width: 80,
    sorting: true,
    renderer: defaultRenderer,
  },
]
